import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ReactSDKClient } from '@sbt-web/houston-wrapper';
import { loadGTMScript } from '@sbt-web/tracking';
import { GTM_URL, GTM_URL_CORE_VITALS_CHECK } from '@/shared/constants';
import WebVitals from '@/client/components/WebVitals';
const TOGGLE_NAME = 'it-subito-gtm-performance-impact';
const GtmWithPerformanceImpact = t0 => {
  const $ = _c(10);
  const {
    optimizely
  } = t0;
  const [loaded, setLoaded] = useState(false);
  const [advDisabled, setAdvDisabled] = useState(false);
  const [gtmDisabled, setGtmDisabled] = useState(false);
  let t1;
  let t2;
  if ($[0] !== optimizely) {
    t1 = () => {
      optimizely.onReady().then(() => {
        setAdvDisabled(optimizely.getVariation("subito-msite-no-adv-flywheel-longterm") === "B");
        setGtmDisabled(optimizely.isFeatureEnabled(TOGGLE_NAME));
        setLoaded(true);
      });
    };
    t2 = [optimizely];
    $[0] = optimizely;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== gtmDisabled || $[4] !== loaded) {
    t3 = () => {
      if (loaded) {
        loadGTMScript(gtmDisabled ? GTM_URL_CORE_VITALS_CHECK : GTM_URL);
      }
    };
    t4 = [gtmDisabled, loaded];
    $[3] = gtmDisabled;
    $[4] = loaded;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  if (!loaded) {
    return null;
  }
  let t5;
  if ($[7] !== advDisabled || $[8] !== gtmDisabled) {
    t5 = <WebVitals gtmDisabled={gtmDisabled} advDisabled={advDisabled} />;
    $[7] = advDisabled;
    $[8] = gtmDisabled;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export { GtmWithPerformanceImpact, TOGGLE_NAME };